module.exports = __webpack_public_path__ + "static/en-3-34e28b318ad09ef256c60c7f311dc666.png";